import { handleConnectionEligibilityData } from '@shared/eligibility/handleConnectionEligibilityData';
import { consoleLogger } from '@shared/logging/consoleLogger';

export const handleIdentificationFailure = () => {
  const connectionEligibilityData = {
    isEligible: false,
    eligibilityCheckTime: Date.now(),
    retryEligibilityCheckTime: Date.now() + 604800000, // 7 days by default
  };

  handleConnectionEligibilityData({
    connectionEligibilityData,
    onEligibilityCheckedCallback: () => void 0,
  });

  consoleLogger.logError(
    'Telco identification call failed. Identification will be checked again in 7 days...',
  );
};
